/* Formelle theme – global.js */
(function () {
  'use strict';

  var F = (window.Formelle = window.Formelle || {});

  /* ---------- Money ---------- */
  F.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || F.moneyFormat || '£{{amount}}';

    function delimit(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }

    var match = fmt.match(placeholder);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = delimit(cents, 2); break;
      case 'amount_no_decimals': value = delimit(cents, 0); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = delimit(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      default: value = delimit(cents, 2);
    }
    return fmt.replace(placeholder, value);
  };

  /* ---------- Cart drawer ---------- */
  var drawer = function () { return document.querySelector('[data-cart-drawer]'); };
  var lastFocus = null;

  F.openCart = function () {
    var d = drawer();
    if (!d) { window.location.href = F.routes.cart_url; return; }
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    var panel = d.querySelector('.cart-drawer__panel');
    if (panel) panel.focus();
  };

  F.closeCart = function () {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus();
  };

  F.renderCartSection = function (html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('.cart-drawer__panel');
    var d = drawer();
    if (fresh && d) {
      d.querySelector('.cart-drawer__panel').innerHTML = fresh.innerHTML;
    }
    var body = doc.querySelector('[data-cart-items]');
    var count = body ? parseInt(body.getAttribute('data-count'), 10) || 0 : null;
    if (count !== null) F.updateCount(count);
  };

  F.updateCount = function (count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  };

  F.addItems = function (items) {
    var body = {
      items: items,
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    };
    return fetch(F.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) {
          throw new Error(res.json.description || res.json.message || F.strings.error);
        }
        if (F.cartAction === 'checkout') { window.location.href = '/checkout'; return res.json; }
        if (F.cartAction === 'cart') { window.location.href = F.routes.cart_url; return res.json; }
        if (res.json.sections) F.renderCartSection(res.json.sections['cart-drawer']);
        F.openCart();
        document.dispatchEvent(new CustomEvent('formelle:cart:added', { detail: res.json }));
        return res.json;
      });
  };

  F.changeLine = function (line, quantity) {
    var d = drawer();
    if (d) d.classList.add('is-loading');
    return fetch(F.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.sections) F.renderCartSection(json.sections['cart-drawer']);
      })
      .finally(function () { if (d) d.classList.remove('is-loading'); });
  };

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn && drawer() && F.cartAction === 'drawer') { e.preventDefault(); F.openCart(); return; }

    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); F.closeCart(); return; }

    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      F.changeLine(parseInt(qtyBtn.getAttribute('data-qty-change'), 10), parseInt(qtyBtn.getAttribute('data-qty-value'), 10));
      return;
    }

    var navBtn = e.target.closest('[data-nav-toggle]');
    if (navBtn) {
      var nav = document.querySelector('[data-mobile-nav]');
      if (!nav) return;
      var open = nav.hidden;
      nav.hidden = !open;
      navBtn.setAttribute('aria-expanded', String(open));
      return;
    }

    var jump = e.target.closest('a[href^="#"]');
    if (jump) {
      var id = jump.getAttribute('href');
      if (id.length > 1) {
        var target = document.querySelector(id);
        if (target) {
          e.preventDefault();
          var header = document.querySelector('[data-header]');
          var offset = header && header.classList.contains('site-header--sticky') ? header.offsetHeight + 12 : 12;
          window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - offset, behavior: 'smooth' });
        }
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      F.closeCart();
      document.querySelectorAll('dialog[open]').forEach(function (d) { d.close(); });
    }
  });

  /* ---------- Countdown to a real deadline ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var end = new Date(el.getAttribute('data-countdown')).getTime();
      if (isNaN(end)) return;
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) { el.hidden = true; clearInterval(timer); return; }
        el.hidden = false;
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        var q = function (sel) { return el.querySelector(sel); };
        if (q('[data-d]')) {
          q('[data-d]').textContent = pad(d);
          q('[data-d]').parentElement.hidden = d === 0;
        }
        if (q('[data-h]')) q('[data-h]').textContent = pad(h);
        if (q('[data-m]')) q('[data-m]').textContent = pad(m);
        if (q('[data-s]')) q('[data-s]').textContent = pad(s);
      }
      var timer = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------- "Ships today" cut-off (real daily cut-off time) ---------- */
  function initDispatch() {
    document.querySelectorAll('[data-dispatch]').forEach(function (el) {
      var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 14;
      var tz = el.getAttribute('data-tz') || 'Europe/London';
      var days = (el.getAttribute('data-days') || '1,2,3,4,5').split(',').map(function (d) { return parseInt(d, 10); });
      var today = el.querySelector('[data-dispatch-today]');
      var later = el.querySelector('[data-dispatch-later]');
      var tpl = today.getAttribute('data-tpl') || today.textContent;
      today.setAttribute('data-tpl', tpl);
      function parts() {
        try {
          var f = new Intl.DateTimeFormat('en-GB', { timeZone: tz, weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
          var o = {};
          f.formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
          var wd = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 }[o.weekday];
          return { wd: wd, h: +o.hour, m: +o.minute, s: +o.second };
        } catch (e) { var d = new Date(); return { wd: d.getDay() || 7, h: d.getHours(), m: d.getMinutes(), s: d.getSeconds() }; }
      }
      function tick() {
        var p = parts();
        var left = cutoff * 3600 - (p.h * 3600 + p.m * 60 + p.s);
        var isDay = days.indexOf(p.wd) !== -1;
        el.hidden = false;
        if (isDay && left > 0) {
          var h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60);
          today.textContent = tpl.replace('[tid]', (h > 0 ? h + 't ' : '') + m + 'm');
          today.hidden = false; later.hidden = true;
        } else {
          today.hidden = true; later.hidden = false;
        }
      }
      tick();
      setInterval(tick, 30000);
    });
  }

  /* ---------- Before / after slider ---------- */
  function initCompareSliders() {
    document.querySelectorAll('[data-ba]').forEach(function (el) {
      var range = el.querySelector('input[type="range"]');
      if (!range || range.__init) return;
      range.__init = true;
      var set = function () { el.style.setProperty('--ba', range.value + '%'); };
      range.addEventListener('input', set);
      set();
    });
  }

  /* ---------- Load more (review wall) ---------- */
  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-load-more]');
    if (!more) return;
    var wrap = document.getElementById(more.getAttribute('data-load-more'));
    if (!wrap) return;
    var hiddenItems = wrap.querySelectorAll('[data-more-hidden]');
    var step = parseInt(more.getAttribute('data-step'), 10) || 6;
    Array.prototype.slice.call(hiddenItems, 0, step).forEach(function (it) { it.removeAttribute('data-more-hidden'); });
    if (wrap.querySelectorAll('[data-more-hidden]').length === 0) more.hidden = true;
  });

  /* ---------- Modal (size guide etc.) ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-modal-open]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-modal-open'));
      if (dlg && dlg.showModal) { e.preventDefault(); dlg.showModal(); }
    }
    var closer = e.target.closest('[data-modal-close]');
    if (closer) { var parent = closer.closest('dialog'); if (parent) parent.close(); }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  /* ---------- Sticky add-to-cart bar ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-sticky-atc]');
    var anchor = document.querySelector('[data-buybox]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var inView = true;
    function update() { bar.classList.toggle('is-visible', !inView && window.pageYOffset > 400); }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { inView = en.isIntersecting; update(); });
    });
    io.observe(anchor);
    window.addEventListener('scroll', update, { passive: true });
  }

  function initAll() {
    initCountdowns();
    initSticky();
    initDispatch();
    initCompareSliders();
  }
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
